import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[onlyNumbers]'
})
export class OnlyNumbersDirective {

  @Output() ngModelChange = new EventEmitter();

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Delete', 'Tab'];

    if (event.key === '+' || event.key === '-') {
      event.preventDefault();
    } else if (!allowedKeys.includes(event.key) && (event.key < '0' || event.key > '9')) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value;
    let parsedValue = initialValue.replace(/[^0-9]/g, '');

    while (parsedValue.length > 1 && parsedValue.charAt(0) === '0') {
      parsedValue = parsedValue.substr(1);
    }

    if (parsedValue === '0') {
      parsedValue = null;
    }

    if (initialValue !== parsedValue) {
      this.el.nativeElement.value = parsedValue;
      event.stopPropagation();
      event.preventDefault();
      this.ngModelChange.emit(parsedValue);
    }
  }
}


